<template>
  <BreadCrumb PageTitle="Liste des nouveaux colis" />
  <NewColisListe />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import NewColisListe from "../../components/Colis/NewColisListe.vue";

export default defineComponent({
  name: "NewColisListePage",
  components: {
    BreadCrumb,
    NewColisListe,
  },
});
</script>